// The API orders the complete result set by group before applying pagination.
// Only partition the current page here; never duplicate a note across shelves.
export function groupLibraryItems(items, groupBy) {
  const groups = new Map();
  for (const item of items) {
    const value = groupBy === 'topic' ? item.topic || ''
      : groupBy === 'language' ? item.learningLocale || '' : String(item.difficulty || '');
    if (!groups.has(value)) groups.set(value, { value, items: [] });
    groups.get(value).items.push(item);
  }
  return [...groups.values()];
}
